'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var DayPickerKeyboardShortcuts = {};

exports.__exports = DayPickerKeyboardShortcuts;
